import { mailtoBugReport } from "util";

import PropTypes from "prop-types";
import { Component } from "react";
import Alert from "react-bootstrap/Alert";
import ReactGA from "react-ga4";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static getDerivedStateFromError(error) {
    return { error, hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    ReactGA.event({ action: error.message, category: "Errors", label: "ErrorBoundary" });
  }

  render() {
    if (this.state.hasError) {
      const stack = this.state.error.stack || this.state.error.message;
      return (
        <Alert className="m-4" variant="danger">
          <h4>An error occurred</h4>
          <p className="mb-2">Something went wrong, and our team has been automatically notified.</p>
          {stack && <code>{stack}</code>}
          <p className="mb-0 mt-2">
            You can email us at{" "}
            <a href={mailtoBugReport(stack)} target="_blank" rel="noreferrer">
              bugreport@edhrec.com
            </a>
            .
          </p>
        </Alert>
      );
    } else {
      return this.props.children;
    }
  }
}
